export default __webpack_public_path__ + "static/media/Fion-Lee-Madan.b7bd1eca.jpeg";